module.exports = __webpack_public_path__ + "static/media/Dog.6ffba2c1.jpeg";